"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/chat/v1/portal_service.proto (package spwn.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalChatService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.chat.v1.PortalChatService
 */
exports.PortalChatService = {
    typeName: "spwn.chat.v1.PortalChatService",
    methods: {
        /**
         * @generated from rpc spwn.chat.v1.PortalChatService.SaveStreamingAnnouncement
         */
        saveStreamingAnnouncement: {
            name: "SaveStreamingAnnouncement",
            I: portal_service_pb_1.PortalChatServiceSaveStreamingAnnouncementRequest,
            O: portal_service_pb_1.PortalChatServiceSaveStreamingAnnouncementResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map